<template>
  <div class="content">
    <p v-if="!readMoreToggle" v-html="content" />
    <p v-else>
      <span v-html="parseContent(content)" />
      <span
        v-if="readMoreToggle && !collapsed"
        class="toggle"
        @click="toggleContent"
        >{{ showText }}</span
      >
      <span
        v-if="readMoreToggle && collapsed"
        class="toggle"
        @click="toggleContent"
        >{{ hideText }}</span
      >
    </p>
  </div>
</template>

<script>
export default {
  name: "ReadMore",
  props: {
    showText: { default: "Meer" },
    hideText: { default: "Minder" },
    ellips: { default: false },
    maxChar: { default: 50 },
    content: { default: "This is a read-more component" }
  },
  data: function() {
    return {
      readMoreToggle: this.maxChar - this.content.length < 0,
      collapsed: false
    };
  },
  methods: {
    toggleContent: function(e) {
      this.collapsed = !this.collapsed;
    },
    parseContent: function(text) {
      return this.collapsed
        ? this.content
        : this.content.substring(0, this.maxChar) + (this.ellips ? "..." : "");
    }
  }
};
</script>

<style lang="scss" scoped>
.toggle,
.tag {
  text-decoration: underline;
  display: inline-block;
  color: #c6c6c6;
  cursor: pointer;
}

p {
  word-break: break-word;
  white-space: pre-line;
}

.content .linkified {
}
</style>
